// https://www.digitalocean.com/community/tutorials/how-to-add-login-authentication-to-react-applications
// https://wordpress.stackexchange.com/questions/311825/how-to-login-via-wordpress-api-and-get-user-details

import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import useToken from '../../hooks/useToken.js'
import { MainContext } from '../../contexts/MainContext'
import { fetchCurrentUser, fetchCurrentUserData, createUser, authorizeUser } from '../../fetch/WPAPI'

async function loginUser(credentials) {
  return await authorizeUser(credentials.email, credentials.password)
}

async function registerUser(credentials) {
  return await createUser(credentials.email, credentials.password, credentials.username)
}

const RegistrationForm = (props) => {
  const { token, setToken } = useToken()
  const navigate = useNavigate()
  const mainContext = useContext(MainContext)
  
  useEffect(() => {
    if (token && token.token) {
      navigate('/me')
    }
  }, [])

  const [ email, setEmail ] = useState('')
  const [ password, setPassword ] = useState('')
  const [ repeatPassword, setRepeatPassword ] = useState('')

  const [ registrationFail, setRegistrationFail ] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()

    setRegistrationFail(false)

    // let username = email.substring(0, email.indexOf('@'))
    
    const result = await registerUser({
      email: email,
      password: password,
      username: email,
    })

    console.log(result)

    if (result?.code != 200) {
      setRegistrationFail(result?.message)
    } else {
      // Perform Login
      const result = await loginUser({
        email,
        password
      })
      console.log(result)
      if (result.data?.status == 403) {
        // setLoginFail(true)
      } else {
        setToken(result)
        if (!mainContext.userData.id) {
          fetchCurrentUser(result.token)
            .then(result => {
              // console.log(result)
              if (result.id) {
                fetchCurrentUserData(result.id)
                  .then(resultWoo => {
                    // console.log(resultWoo)
                    if (resultWoo.id) {
                      mainContext.setUserData(resultWoo)
                      mainContext.setUserWpData(result)
                      navigate('/me')
                    } else {
                      setToken(null)
                      // setLoginFail(true)
                    }
                  })
              } else {
                setToken(null)
                // setLoginFail(true)
              }
            })
        }
      }
    }
  }

  return <div className="af-class-log-in__form-block w-form">
    <form onSubmit={handleSubmit} id="wf-form-Log-in-form" className="af-class-log-in__form">
      { registrationFail && <div style={{ color: 'red' }}>{registrationFail}</div> }
      <div className="w-layout-grid af-class-log-in__form-grid">
        <input type="email" className="af-class-cart__user-field w-input" maxLength={256} placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <input type="password" className="af-class-cart__user-field w-input" maxLength={256} placeholder="Пароль" required value={password} onChange={(e) => setPassword(e.target.value)} />
        <input type="password" className="af-class-cart__user-field w-input" maxLength={256} placeholder="Повторите пароль" required value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)} />
      </div>
      <input type="submit" value="Регистрация" id="w-node-e7a94754-e4e9-6a82-3200-ab774fd248cc-b23d362e" className="af-class-button--primary af-class-log-in w-button" />
      <div className="af-class-log-in__caption">Регистрируясь на сайте Rockets coffee вы принимаете <a onClick={() => navigate(`/user-agreement`)} href="#" className="af-class-log-in__caption-link">пользовательское соглашение.</a>
      </div>
    </form>
  </div>
}

export default RegistrationForm